// Icons for the classes lucide has no icon for (#982), drawn in lucide's own
// frame and stroke so they sit next to Truck, Bus and Tractor unnoticed.
import type { ReactNode } from 'react'

function strokeIcon(paths: ReactNode) {
  return function StrokeIcon({ className }: { className?: string }) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
        {paths}
      </svg>
    )
  }
}

export const Motorsykkel = strokeIcon(<>
  <circle cx="5" cy="17" r="3" /><circle cx="19" cy="17" r="3" />
  <path d="M5 17l4-6h5l5 6" /><path d="M14 11l-2-4h-2" /><path d="M15 7h3" />
</>)

export const Moped = strokeIcon(<>
  <circle cx="6" cy="18" r="2.5" /><circle cx="18" cy="18" r="2.5" />
  <path d="M8.5 18H15l1.5-6h-5" /><path d="M16.5 12L17 6h2.5" /><path d="M9 12h3" />
</>)

export const Tilhenger = strokeIcon(<>
  <rect x="2" y="7" width="15" height="9" rx="1" /><circle cx="9.5" cy="18" r="2" /><path d="M17 14h5" />
</>)

export const Bobil = strokeIcon(<>
  <path d="M5.5 17H2V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v2h-4l3 3h1a2 2 0 0 1 2 2v4h-2.5" /><path d="M9.5 17h6" />
  <circle cx="7.5" cy="17.5" r="2" /><circle cx="17.5" cy="17.5" r="2" /><rect x="5" y="9" width="4" height="3" rx="0.5" />
</>)

export const Beltemotorsykkel = strokeIcon(<>
  <path d="M2 20h8" /><path d="M2 20c0-1.5 1-2.5 2.5-2.5" /><rect x="11" y="15" width="11" height="5" rx="2.5" />
  <path d="M6 17.5L9 12h7l3 3" /><path d="M10 12l1-3h3" />
</>)
